<div style="margin-left: 0px;" class="content-wrapper" id="content-wrapper">
  <section class="content-header">
    <h1>
      Holerite
    </h1>
    <ol class="breadcrumb">
      <li><i class="fa fa-dashboard"></i>&nbsp;&nbsp;&nbsp;Home</li>
      <li>Importação</li>
      <li class="active">Holerite</li>
    </ol>
  </section>

  <!-- modalp popup ends -->
  <section class="content">

    <form id="formulario">
      <div style="margin-left: 0px;">
        <div class="box box-primary">
          <div class="box-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Anexar</label>
                  <div class="input-group date">
                    <input disabled style="background-color: white;" type="text" class="form-control pull-right"
                      id="txtArquivo" name="txtArquivo" placeholder="Escolher Arquivo">
                    <div class="input-group-addon" style="padding: 0px;">
                      <div class="fa fa-upload btn btn-file">
                        <input class="ignore" type="file" name="inputFoto" #imageInput type="file"
                          (change)="processFile(imageInput)">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Nome da Empresa</label>
                  <!-- BUSCAR OS DADOS DA TABELA Empresa  -->
                  <div class="input-group">
                    <input type="text" class="form-control" id="txtNomeEmpresa" name="txtNomeEmpresa"
                      placeholder="Nome da Empresa">
                    <span class="input-group-addon"><a style="cursor: pointer;" (click)="openModal('modalEmpresa')"
                        title="Pesquisar Empresa"><i class="fa fa-search"></i></a></span>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Tipo</label>
                  <select-component (changeValue)="changeSelectValues($event)" [Data]="tipoList" IdSelect="selTipo"
                    [Value]="tipoSelected">
                  </select-component>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Mês</label>
                  <select-component (changeValue)="changeSelectValues($event)" [Data]="mesList" IdSelect="selMes"
                    [Value]="mesSelected">
                  </select-component>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Ano</label>
                  <input type="text" mask="0000" class="form-control" id="txtAno" name="txtAno" placeholder="yyyy">
                </div>
              </div>
            </div>
          </div>

          <div class="box-footer">
            <table border=0 width="100%">
              <tr width="100%">
                <td align="left"><button type="reset" (click)="clearInputvalues()"
                    class="btn btn-default">Limpar</button>
                </td>
                <td align="center"><span id="spanErro" name="spanErro" class="error" style="font-weight: bold;"></span>
                </td>
                <td align="right">
                  <input value="Importar" readonly="readonly" (click)="importar()"
                    class="btn btn-info pull-right btn-margin" />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div id="tableResult" class="box box-body" style="visibility: hidden;">
        <div style="overflow-y: auto;">
          <div style="width: 99%; padding-left: 15px;">
            <table #grid style="width: 100% !important;" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th style="width: 15% !important">Matrícula do Colaborador</th>
                  <th style="width: 15% !important">Nome da Empresa</th>
                  <th style="width: 15% !important">Mês</th>
                  <th style="width: 15% !important">Ano</th>
                  <th style="width: 15% !important">Erro</th>
                  <th style="width: 15% !important">Data da Importação</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
    </form>
  </section>

  <div class="control-sidebar-bg"></div>
</div>

<div class="modal fade" id="modalEmpresa" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="exampleModalLabel"><b>Empresa</b></h4>
      </div>
      <div class="modal-body">
        <table #gridModalEmpresa style="width: 100% !important; cursor: pointer;"
          class="hover tableOperadora table table-bordered table-striped">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Cnpj</th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default pull-right" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
